module.exports = __webpack_public_path__ + "static/img/cold_sweat.eeee348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/cold_sweat.png
// module id = gfuq
// module chunks = 0